import Layout from '!/components/Layout';
import SearchProvider from '!/components/SearchProvider';
import withRedux from 'next-redux-wrapper';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { parse as parseUrl } from 'url';
import { initStoreAction, updateSettings } from '../actions/creators';
import configureStore from '../store/configureStore';
import { default as Head } from "next/head";

//const Head = dynamic(_ => import('next/head'));

function getStateFromPath(path) {
  try {
    const query = parseUrl(path, true).query;
    let page = Number(query.p);
    if (page <= 1 || isNaN(page)) {
      page = 1;
    }
    const pattern = /^f\[\d+\]\[(.*?)\]\[\d+\]$/;
    const values = Object.keys(query)
      .filter(param => pattern.test(param))
      .reduce((result, name) => {
        const filterName = name.match(pattern)[1];

        if (!result[filterName]) {
          result[filterName] = [];
        }

        result[filterName].push(query[name]);
        return result;
      }, {});

    if (query.sort) {
      values.sort = query.sort;
    }

    return { values, applied: Object.keys(values).filter(key => key !== 'sort'), page };
  } catch (e) {
    console.error(e);
    return {};
  }
}

class SearchPage extends Component {
  static childContextTypes = {
    isDebugMode: PropTypes.bool,
    isStandalone: PropTypes.bool,
  };

  static propTypes = {
    isServer: PropTypes.bool,
    isDebugMode: PropTypes.bool,
    isStandalone: PropTypes.bool,
  };

  // TODO: Legacy context - https://reactjs.org/docs/legacy-context.html
  // getChildContext() {
  //   return {
  //     isDebugMode: this.props.isDebugMode,
  //     isStandalone: this.props.isStandalone,
  //   };
  // }

  static async getInitialProps({ store, isServer, query }) {
    const { initialStoreState = {}, settings = {}, isDebugMode, isStandalone } = query;

    if (isServer) {
      store.dispatch(initStoreAction(initialStoreState));
      store.dispatch(updateSettings(settings));
    }

    return { isDebugMode: Number(isDebugMode) === 1, isStandalone: Number(isStandalone) === 1 };
  }

  render() {
    return (
      <Fragment>
        {this.props.isStandalone && (
          <Head>
            <link
              rel="stylesheet"
              type="text/css"
              href="https://cdn2.vitafy.de/skin/frontend/vitafy/default/css/styles.css"
            />
            <link
                rel="stylesheet"
                type="text/css"
                href="https://vitafy.de/react-components/style-gq.css"
            />
            <script src="https://unpkg.com/react@16/umd/react.development.js" crossOrigin={true}></script>
            <script src="https://unpkg.com/react-dom@16/umd/react-dom.development.js" crossOrigin={true}></script>
            <script src="https://vitafy.de/react-components/index.js" crossOrigin={true}></script>
          </Head>
        )}
        <SearchProvider api="/search">
          <Layout />
        </SearchProvider>
      </Fragment>
    );
  }
}

export default withRedux(configureStore, null)(SearchPage);
